import { render, staticRenderFns } from "./grabSuccess.vue?vue&type=template&id=52cc8948&scoped=true&"
import script from "./grabSuccess.vue?vue&type=script&lang=js&"
export * from "./grabSuccess.vue?vue&type=script&lang=js&"
import style0 from "./grabSuccess.vue?vue&type=style&index=0&id=52cc8948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc8948",
  null
  
)

export default component.exports